import React, { useState } from 'react'
import MyTextInput from '../../app/common/form/MyTextInput'
import { Formik } from 'formik'
import * as Yup from 'yup'
import agent from '../../app/api/agent'
import AuthShell from '../../app/common/ui/AuthShell'
import { AppButton, AppStack, AppText } from '../../app/common/ui'

export default function ForgotPasswordForm () {
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)

  return (
    <AuthShell title={submitted ? 'CHECK YOUR EMAIL' : 'FORGOT PASSWORD'}>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={Yup.object({ email: Yup.string().required().email() })}
        onSubmit={async (values) => {
          setError(null)
          try {
            await agent.Account.forgotPassword(values.email)
            setSubmitted(true)
          } catch (e: any) {
            setError(e?.response?.data?.detail || 'Something went wrong. Try again.')
          }
        }}
      >
        {({ handleSubmit, isSubmitting, isValid, dirty }) =>
          submitted
            ? (
            <AppStack spacing="sm">
              <AppText size="sm" color="dimmed" align="center">
                If that email is registered, you'll receive a reset link shortly. Check your spam folder too.
              </AppText>
            </AppStack>
              )
            : (
            <form onSubmit={handleSubmit} autoComplete="off">
              <AppStack spacing="sm">
                <MyTextInput name="email" placeholder="Email address" label="Email address" />
                {error && (
                  <AppText size="sm" color="red">
                    {error}
                  </AppText>
                )}
                <AppButton type="submit" disabled={!isValid || !dirty || isSubmitting} loading={isSubmitting} fullWidth>
                  Send reset link
                </AppButton>
              </AppStack>
            </form>
              )
        }
      </Formik>
    </AuthShell>
  )
}
